export const PREPACK_PRODUCT = {
  name: "Mid Rise Stripe Shorts",
  variant: "BLUSH-WHITE STRIPE",
  prepackLabel: "Prepack",
  prepackRatio: "1–2–2–1; XS–L",
  imageUrl: "/images/ck/brand-portal-issues-page/mid-rise-stripe-shorts.png",
};

export const PREPACKS_PURCHASED = 4;
export const ITEMS_PER_PREPACK = 6;

export type PrePackAllItemsAffected = "yes" | "no";

export type PrePackReportContext = {
  allItemsAffected: PrePackAllItemsAffected;
};

export const PREPACK_PARTIAL_RESOLUTION_COPY =
  "Since only some items in the pre-pack were affected, you can request a refund, but not a replacement.";

export const getPrepackCountOptions = () =>
  Array.from({ length: PREPACKS_PURCHASED }, (_, index) => {
    const count = index + 1;
    return {
      value: String(count),
      label: `${count} prepack${count === 1 ? "" : "s"}`,
    };
  });

export const getTotalItemCountOptions = (prepacksAffected: number) => {
  const maxItems = prepacksAffected * ITEMS_PER_PREPACK;

  return Array.from({ length: maxItems }, (_, index) => {
    const count = index + 1;
    return {
      value: String(count),
      label: `${count} item${count === 1 ? "" : "s"}`,
    };
  });
};
